import React from 'react'
import AdminLayout from '../../../layouts/AdminLayout'
import { Navigate, useNavigate } from 'react-router-dom'
import { adminPaths } from '../../../routes/admin';

const ReportDetails = () => {
    const navigate = useNavigate();
  return (
    <div>
        <AdminLayout>
             <div className="ct_px_40 my-5">
                            <div className="container-fluid">
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <a class="ct_fs_14 ct_grey_text d-flex align-items-center gap-2 ct_mb_30 pb-1" onClick={()=> navigate(-1)}><i class="fa-solid fa-arrow-left"></i> Back to Reports</a>
                                         <div className="d-flex align-items-center gap-3 justify-content-between mb-4 ct_flex_col_1199">
                          <div>
                            <h4 className="mb-0 ct_fs_20  mb-0">Report Summary Section</h4>
                            <p className="mb-0 ct_text_clr_757886">
                              A quick breakdown of key insights for this report
                            </p>
                          </div>
                          <div className="d-flex align-items-center gap-3 ct_flex_col_575 ct_w_100_575">
                           
                            <button className='ct_yellow_btn ct_h_40'>
                            Schedule New Report
                            </button>
            
                          </div>
                        </div>
                                    </div>

                                </div>

                                  <div class="row">
            <div class="col-lg-3 col-md-6 ct_mb_30">
              <div class="ct_outline_bg h-100">
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div>
                    <p class="ct_fs_14 ct_darkblue_text ct_mb_16">
                    Active Users
                    </p>
                    <h4 class="ct_fs_24 mb-0">200</h4>
                  </div>
                  <img src="../assets/img/dash_icon_1.png" alt="" />
                </div>
                <ul class="d-flex align-items-center gap-2 ct_mt_16 pb-3">
                  <li class="ct_fs_12 ct_orange_text">
                    <svg
                      width="23"
                      height="24"
                      viewBox="0 0 23 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1696_32114)">
                        <path
                          d="M7.03156 16.2038L15.3574 8.03125"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1696_32114">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(11.418 0.6875) rotate(45.5323)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    24%
                  </li>
                  <li class="ct_text_op_2">|</li>
                  <li class="ct_grey_text ct_fs_12">
                    users currently active on the platform
                  </li>
                </ul>
                <div class="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ">
                  <a href="#" class="ct_yellow_link ct_fs_14">
                    View Report
                  </a>
                  <a href="#">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.834 6.3125L1.16732 6.3125M12.834 6.3125L7.83398 11.3125M12.834 6.3125L7.83398 1.3125"
                        stroke="#FFB703"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 ct_mb_30">
              <div class="ct_outline_bg h-100">
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div>
                    <p class="ct_fs_14 ct_darkblue_text ct_mb_16">
                     Suspended Users
                    </p>
                    <h4 class="ct_fs_24 mb-0">32</h4>
                  </div>
                  <img src="../assets/img/dash_icon_2.png" alt="" />
                </div>
                <ul class="d-flex align-items-center gap-2 ct_mt_16 pb-3">
                  <li class="ct_fs_12 ct_sky_blue_text">
                    38%
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1696_32145)">
                        <path
                          d="M5.73231 8.00261L15.8359 13.8359"
                          stroke="#8ECAE6"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9.74891 15.7105L16.1237 14.0024L14.4156 7.6276"
                          stroke="#8ECAE6"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1696_32145">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(21.8555 8.07031) rotate(120)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </li>
                  <li class="ct_text_op_2">|</li>
                  <li class="ct_grey_text ct_fs_12">accounts that have been suspended by admin </li>
                </ul>
                <div class="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ">
                  <a href="#" class="ct_dark_blue_link ct_fs_14">
                    View Report
                  </a>
                  <a href="#">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.834 6.92969L1.16732 6.92969M12.834 6.92969L7.83398 11.9297M12.834 6.92969L7.83398 1.92969"
                        stroke="#023047"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
         
            <div class="col-lg-3 col-md-6 ct_mb_30">
              <div class="ct_outline_bg h-100">
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div>
                    <p class="ct_fs_14 ct_darkblue_text ct_mb_16">Av. Last Active </p>
                    <h4 class="ct_fs_24 mb-0">48h30m </h4>
                  </div>
                  <img src="../assets/img/dash_icon_4.png" alt="" />
                </div>
                <ul class="d-flex align-items-center gap-2  ct_mt_16 pb-3">
                  <li class="ct_fs_12 ct_orange_text">
                    <svg
                      width="23"
                      height="24"
                      viewBox="0 0 23 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1696_32114)">
                        <path
                          d="M7.03156 16.2038L15.3574 8.03125"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1696_32114">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(11.418 0.6875) rotate(45.5323)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    24%
                  </li>
                  <li class="ct_text_op_2">|</li>
                  <li class="ct_grey_text ct_fs_12">average time since users last logged in</li>
                </ul>
                <div class="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ">
                  <a href="#" class="ct_yellow_link ct_fs_14">
                    View Report
                  </a>
                  <a href="#">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.834 6.92969L1.16732 6.92969M12.834 6.92969L7.83398 11.9297M12.834 6.92969L7.83398 1.92969"
                        stroke="#FFB703"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
               <div class="col-lg-3 col-md-6 ct_mb_30">
              <div class="ct_outline_bg h-100">
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div>
                    <p class="ct_fs_14 ct_darkblue_text ct_mb_16">
                      New Signups
                    </p>
                    <h4 class="ct_fs_24 mb-0">22 </h4>
                  </div>
                  <img src="../assets/img/dash_icon_3.png" alt="" />
                </div>
                <ul class="d-flex align-items-center gap-2 ct_mt_16 pb-3">
                  <li class="ct_fs_12 ct_orange_text">
                    <svg
                      width="23"
                      height="24"
                      viewBox="0 0 23 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1696_32114)">
                        <path
                          d="M7.03156 16.2038L15.3574 8.03125"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1696_32114">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(11.418 0.6875) rotate(45.5323)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    24%
                  </li>
                  <li class="ct_text_op_2">|</li>
                  <li class="ct_grey_text ct_fs_12">
                    new users registered in the past 30 days
                  </li>
                </ul>
                <div class="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ">
                  <a href="#" class="ct_dark_blue_link ct_fs_14">
                    View Report
                  </a>
                  <a href="#">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.834 6.92969L1.16732 6.92969M12.834 6.92969L7.83398 11.9297M12.834 6.92969L7.83398 1.92969"
                        stroke="#023047"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>

           <div className="d-flex align-items-center gap-3 justify-content-between  ct_flex_col_1199">
                          <div>
                            <h4 className="mb-0 ct_fs_20  mb-0">Data Table</h4>
                            <p className="mb-0 ct_text_clr_757886">
                             Manage all uploaded google ads in one place. View status, make edits, or track performance
                            </p>
                          </div>
                          <div className="d-flex align-items-center gap-3 ct_flex_col_575 ct_w_100_575">
                            <div className="position-relative ct_w_100_575">
                              <input
                                type="text"
                                className="form-control ct_input ct_h_40 ps-5 ct_border_radius_20"
                                placeholder="Search by Name"
                              />
                              <i className="fa-solid fa-search ct_input_icon_left"></i>
                            </div>
                           
                          </div>
                        </div>
                                <div className="row gx-5 ct_mt_40">
                                      <div className="col-lg-2 col-md-3 mb-4 mb-md-0">
                          <h4 className="mb-0 ct_fs_20 mb-4">Reports</h4>
                          <div className="ct_filter_btn">
                            <button
                              className="ct_outline_grey ct_yellow_btn ct_h_35 d-flex align-items-center gap-2"
                             
                            >
                              Filter <img src="/assets/img/octicon_filter-16.png" alt="" />
                            </button>
                          </div>
                          <div
                            className="ct_filter_sidebar ct_custom_scroll p-0 mt-4 "
                          >
                            <div
                              className="ct_close_filter d-block d-lg-none"
                            
                            >
                              <i className="fa-solid fa-xmark"></i>
                            </div>
                            <div className="mt-4">
                              <h5 className="ct_fs_16 mb-3">User Type</h5>
                              <ul>
                                <li>
                                  <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDefault"
                                    />
                                    <label for="" className="ct_text_clr_757886">
                                      Freelancer
                                    </label>
                                  </div>
                                </li>
                                <li className="mt-2">
                                  <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDefault"
                                    />
                                    <label for="" className="ct_text_clr_757886">
                                      Coach  
                                    </label>
                                  </div>
                                </li>
                                <li className="mt-2">
                                  <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDefault"
                                    />
                                    <label for="" className="ct_text_clr_757886">
                                     Founder
                                    </label>
                                  </div>
                                </li>
                                <li className="mt-2">
                                  <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDefault"
                                    />
                                    <label for="" className="ct_text_clr_757886">
                                      Admin
                                    </label>
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div className="mt-4">
                              <h5 className="ct_fs_16 mb-3">Account Status</h5>
                              <ul>
                                <li>
                                  <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDefault"
                                    />
                                    <label for="" className="ct_text_clr_757886">
                                      Active
                                    </label>
                                  </div>
                                </li>
                                <li className="mt-2">
                                  <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDefault"
                                    />
                                    <label for="" className="ct_text_clr_757886">
                                      Suspended
                                    </label>
                                  </div>
                                </li>
                                <li className="mt-2">
                                  <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDefault"
                                    />
                                    <label for="" className="ct_text_clr_757886">
                                   Inactive
                                    </label>
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div className="mt-4">
                              <h5 className="ct_fs_16 mb-3">Sort By</h5>
                              <ul>
                                <li>
                                  <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDefault"
                                    />
                                    <label for="" className="ct_text_clr_757886">
                                      Date Created
                                    </label>
                                  </div>
                                </li>
                                <li className="mt-2">
                                  <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDefault"
                                    />
                                    <label for="" className="ct_text_clr_757886">
                                      Last Active
                                    </label>
                                  </div>
                                </li>
                                <li className="mt-2">
                                  <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDefault"
                                    />
                                    <label for="" className="ct_text_clr_757886">
                                      Name A-Z
                                    </label>
                                  </div>
                                </li>
                               
                              
                              </ul>
                            </div>
                             <div className="mt-4">
                              <h5 className="ct_fs_16 mb-3">Date Range</h5>
                              <ul>
                                <li>
                                  <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDefault"
                                    />
                                    <label for="" className="ct_text_clr_757886">
                                      Today
                                    </label>
                                  </div>
                                </li>
                                <li className="mt-2">
                                  <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDefault"
                                    />
                                    <label for="" className="ct_text_clr_757886">
                                     Last 7 Days
                                    </label>
                                  </div>
                                </li>
                                <li className="mt-2">
                                  <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDefault"
                                    />
                                    <label for="" className="ct_text_clr_757886">
                                      Last 30 Days
                                    </label>
                                  </div>
                                </li>
                                   <li className="mt-2">
                                  <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDefault"
                                    />
                                    <label for="" className="ct_text_clr_757886">
                                      Custom Range
                                    </label>
                                  </div>
                                </li>
                               
                              
                              </ul>
                            </div>
                          
                          </div>
                        </div>
                                    <div className='col-lg-10 col-md-9 mb-4 mb-md-0'>
                                         
            
            
                         <div class="table-responsive ct_custom_table ct_custom_table2 pt-2">
                        <table class="table">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Role</th>
                              <th>Status</th>
                              <th>Joined On</th>
                              
                              <th>Last Active</th>
                            <th>Country</th>
                            
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                              <div class="d-flex align-items-center gap-3">
                      <img src="../assets/img/user_22.jpeg" class="ct_img_40"/>
                      <div>
                        <h5 class="ct_fs_16 ct_fw_600 mb-1">Nuray Aksoy</h5>
                        <p class="mb-0 ct_grey_text">nukrayaksoy@gmail.com</p>
                      </div>
                    </div>
                              </td>
                              <td>Coach</td>
                              <td>
                                <span class="ct_publish_badge px-2">Active</span>
                              </td>
                              <td>April 20, 2025</td>
                              <td>June 18, 2025</td>
                              <td>United States</td>
                          
                              
                            </tr>
                              <tr>
                              <td>
                              <div class="d-flex align-items-center gap-3">
                      <img src="../assets/img/user_22.jpeg" class="ct_img_40"/>
                      <div>
                        <h5 class="ct_fs_16 ct_fw_600 mb-1">Nuray Aksoy</h5>
                        <p class="mb-0 ct_grey_text">nukrayaksoy@gmail.com</p>
                      </div>
                    </div>
                              </td>
                              <td>Freelancer</td>
                              <td>
                                <span class="ct_suspended px-2">Suspended</span>
                              </td>
                              <td>April 20, 2025</td>
                              <td>June 18, 2025</td>
                              <td>United States</td>
                          
                              
                            </tr>
                              <tr>
                              <td>
                              <div class="d-flex align-items-center gap-3">
                      <img src="../assets/img/user_22.jpeg" class="ct_img_40"/>
                      <div>
                        <h5 class="ct_fs_16 ct_fw_600 mb-1">Nuray Aksoy</h5>
                        <p class="mb-0 ct_grey_text">nukrayaksoy@gmail.com</p>
                      </div>
                    </div>
                              </td>
                              <td>Freelancer</td>
                              <td>
                                <span class="ct_suspended px-2">Suspended</span>
                              </td>
                              <td>April 20, 2025</td>
                              <td>June 18, 2025</td>
                              <td>United States</td>
                          
                              
                            </tr>
                              <tr>
                              <td>
                              <div class="d-flex align-items-center gap-3">
                      <img src="../assets/img/user_22.jpeg" class="ct_img_40"/>
                      <div>
                        <h5 class="ct_fs_16 ct_fw_600 mb-1">Nuray Aksoy</h5>
                        <p class="mb-0 ct_grey_text">nukrayaksoy@gmail.com</p>
                      </div>
                    </div>
                              </td>
                              <td>Freelancer</td>
                              <td>
                                <span class=" ct_inactive_badge px-2">Inactive</span>
                              </td>
                              <td>April 20, 2025</td>
                              <td>June 18, 2025</td>
                              <td>United States</td>
                          
                              
                            </tr>
                           
                          </tbody>
                        </table>
                      </div>
            
                                    </div>
                                </div>
                            </div>
                        </div>
        </AdminLayout>
    </div>
  )
}

export default ReportDetails